import { Chip, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";
import {
  LocalFlorist,
  AcUnit,
  Opacity,
  BrightnessHigh,
} from "@mui/icons-material";

const FilterFloweringTime = ({ value, onChange }) => {
  const handleClick = (time) => {
    const selected = value.includes(time)
      ? value.filter((item) => item !== time)
      : [...value, time];

    onChange(selected);
  };

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Flowering Time
      </Typography>
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
        <Chip
          icon={<LocalFlorist />}
          label="Spring"
          clickable
          color={value.includes("spring") ? "primary" : "default"}
          onClick={() => handleClick("spring")}
        />
        <Chip
          icon={<BrightnessHigh />}
          label="Summer"
          clickable
          color={value.includes("summer") ? "primary" : "default"}
          onClick={() => handleClick("summer")}
        />
        <Chip
          icon={<AcUnit />}
          label="Autumn"
          clickable
          color={value.includes("autumn") ? "primary" : "default"}
          onClick={() => handleClick("autumn")}
        />
        <Chip
          icon={<Opacity />}
          label="Winter"
          clickable
          color={value.includes("winter") ? "primary" : "default"}
          onClick={() => handleClick("winter")}
        />
      </Stack>
    </>
  );
};

FilterFloweringTime.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default FilterFloweringTime;
